/**
 * This file is part of ONP.
 *
 * Copyright (c) Opensoft (http://opensoftdev.com)
 *
 * The unauthorized use of this code outside the boundaries of
 * Opensoft is prohibited.
 *
 * @author Evgeny Sapozhnikov <evgeny.sapozhnikov@opensoftdev.com>
 */
import 'APP_THEME/_common/main_page_blocks/index.less';

$(function() {
    $('.featured-prods-dynamic').on('click', '.featured-prod', function() {
        const link = $(this)
            .find('.block-link')
            .attr('href');
        if (link) {
            window.location.href = link;
        }
    });
});
